import { getDecodedShopifyProductIdString } from "@utils/index"
import React from "react"

const MAESTRA_LOGIN = "maestra_authorized"
const MAESTRA_VIEW_CATEGORY = "maestra_view_category"
const MAESTRA_VIEW_PRODUCT = "maestra_view_product"
const MAESTRA_SET_CART = "maestra_set_cart"

export interface MaestraProduct {
  price: string
  productId: string
  quantity: number
}

export interface MaestraUser {
  email: string
}

const formatProduct = ({ price, productId, quantity }: MaestraProduct) => {
  const product: {
    id: string
    pricePerItem: string
    quantity: number
  } = {
    id: getDecodedShopifyProductIdString(productId),
    pricePerItem: price,
    quantity: quantity,
  }

  return product
}

const getDataLayer = (): any[] | undefined => {
  if (typeof window === "undefined") {
    return undefined
  }

  const w = window as any
  w.dataLayer = w.dataLayer || []
  return w.dataLayer
}

export default () => {
  const dataLayer = getDataLayer()

  const maestraOnLogin = React.useCallback(
    (user: MaestraUser) => {
      if (dataLayer) {
        dataLayer.push({
          customerEmail: user.email,
          event: MAESTRA_LOGIN,
        })
      }
    },
    [dataLayer]
  )

  const maestraOnViewCategory = React.useCallback(
    ({ category, user }: { category: string; user: MaestraUser }) => {
      if (dataLayer) {
        dataLayer.push({
          categoryId: category,
          customerEmail: user.email,
          event: MAESTRA_VIEW_CATEGORY,
        })
      }
    },
    [dataLayer]
  )

  const maestraOnViewProduct = React.useCallback(
    ({ product, user }: { product: string; user: MaestraUser }) => {
      if (dataLayer) {
        dataLayer.push({
          customerEmail: user.email,
          event: MAESTRA_VIEW_PRODUCT,
          productId: product,
        })
      }
    },
    [dataLayer]
  )

  const maestraOnSetCart = React.useCallback(
    ({ items, user }: { items: Array<MaestraProduct>; user: MaestraUser }) => {
      if (dataLayer) {
        dataLayer.push({
          customerEmail: user.email,
          event: MAESTRA_SET_CART,
          items: items.map(formatProduct),
        })
      }
    },
    [dataLayer]
  )

  return {
    maestraOnLogin,
    maestraOnSetCart,
    maestraOnViewCategory,
    maestraOnViewProduct,
  }
}
